import "core-js/modules/es.array.includes.js";
import _ from "lodash";
import url from "url";
import qs from "qs";
export const hasHttp = url => {
  return _.includes(url, "http");
};
const urlToObj = redireact => {
  const u = decodeURIComponent(redireact);
  return url.parse(u);
};
export const getAppCode = (redireact, queryCode) => {
  const search = qs.parse(urlToObj(redireact).query);
  return _.get(search, queryCode);
};
export const getRedirect = (search, hash) => {
  const sh = qs.parse(search, {
    ignoreQueryPrefix: true
  });
  const redirect = _.get(sh, "redirect");
  return redirect ? redirect + hash : "";
};
export const getWXCode = to => {
  // const search = qs.parse(location.search, { ignoreQueryPrefix: true });
  return _.get(to, "query.code") || _.get(to, "query.authCode");
};
export const getUUID = to => {
  // const search = qs.parse(location.search, { ignoreQueryPrefix: true });
  return _.get(to, "query.state");
};
export const appendTicket = (redireact, ticket) => {
  //添加ticket参数
  return ticket;
};